import { Vue } from 'vue-class-component';
import styles from './styles.module.scss';

export class Skeleton extends Vue {
	render() {
		return (
			<div class={ styles.skeleton }>
				<div class={ styles.skeletonContent }></div>
			</div>
		);
	}
}
